import templateUrl from "./security-nav.component.html";

export const SecurityNavComponent = {
    templateUrl,
    controller: class {
        constructor($state) {
            'ngInject';
            this.$state = $state;
        }
    }
}
